'use strict'
import $ from 'jquery'
import axios from 'axios'
import toastr from '../plugins/toastr2'

export default class MetaForm {

    constructor(form) {
        this.form = form;
        this.initializeEvents();
        form.removeAttr('[data-ajax-init]');
    }

    get fromData() {
        return this.form.serialize();
    }

    get method() {
        return this.form.attr('method');
    }

    get action() {
        return this.form.attr('action');
    }

    get data() {
        let data = this.form.serialize();
        if (typeof this.password !== 'undefined')
            data = data + '&' + 'form-password-confirmation=' + this.password;
        return data;
    }

    get dataFormAction() {
        return this.form.attr('data-form-action')
    }

    get confirmationText() {
        return this.form.attr('data-form-confirmation-text');
    }

    initializeEvents() {
        /**
         * Отключаем подтверждение формы
         */
        this.form.submit((event) => {
            event.preventDefault();
            if (typeof this.form.attr('data-form-confirmation') !== 'undefined') {
                if (this.requestPassword()) {
                    this.ajax();
                } else
                    alert('Вы отменили действие')
            } else
                this.ajax();
            return false;
        });
    }

    // appendPasswordInput()

    ajax() {
        console.log('send:', this.data);
        axios
            .request({
                url: this.action,
                method: this.method,
                data: this.data,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                }
            })
            .then((response) => {
                let data = response.data
                console.log('response:', data);
                switch (this.dataFormAction) {
                    case 'delete':
                        this.form.remove();
                        break
                    case 'update':
                        if (data.model_data) {
                            for (let key in data.model_data) {
                                if (key && data.model_data[key]) {
                                    this.form.find('[name="' + key + '"]').val(data.model_data[key])
                                }
                            }
                        }
                        break
                    default:
                }
                if (data.flashMessages) {
                    data.flashMessages.forEach(function (item) {
                        if (item.type && item.text) {
                            toastr[item.type](item.text)
                        }
                    })
                }

            })
            .catch(function (error) {
                if (error.response.status === 422) {
                    toastr['error']('Неправильный пароль')
                } else {
                    toastr['alert']('Изменения прошли успешно')
                }
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)

                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message)
                }
            })
            .then(function () {
                // always executed
            })
    }

    requestPassword() {
        let promptText = 'Введите пароль, чтобы продолжить';
        if (typeof this.confirmationText !== 'undefined')
            promptText = this.confirmationText;
        let password = prompt(promptText);
        let result = false;
        if (password !== null) {
            this.password = password;
            result = true;
        }
        return result;
    }


    static init() {
        /**
         * Функция инициализации
         */
        $('form[data-ajax-init]')
            .each(function (key, value) {
                let form = $(value);
                /**
                 * На каждую форму создаем экземпляр класса MetaForm
                 */
                new MetaForm(form);
                /**
                 * Помечаем каждую форму, что она инициализирована и защищаем от переинициализации
                 * Нужно в случае, когда через ajax подключается html (В таком случае всегда надо делать переинициализацию)
                 * И чтобы уже инициализированные формы не переинициализировать удаляем у них атрибут data-ajax-init и добавляем inited
                 */
                form.attr('data-ajax-init', true);
            })
    }

}

MetaForm.init();
